import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { initTelegram, isInTelegram } from './lib/telegram'
import { useAuthStore } from './stores/auth'
import './style.css'

async function boot() {
  // 1. Init Telegram WebApp (ready + expand + theme lock)
  initTelegram()

  const app = createApp(App)
  const pinia = createPinia()
  app.use(pinia)
  app.use(router)

  // 2. Seamless auto-login เฉพาะใน Telegram Mini App (ส่ง initData ของจริง)
  //    บน browser ปกติ → ปล่อยให้ router เด้ง /login + LoginView mount Telegram Login Widget
  if (isInTelegram()) {
    const auth = useAuthStore()
    try {
      await auth.ensureAuth()
    } catch (e) {
      console.warn('Mini App auto-login failed, จะแสดงหน้า /login ให้กดเอง', e)
    }
  }

  app.mount('#app')
}

boot().catch((e) => {
  console.error('boot failed', e)
})
